<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Annonce</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/descriptif.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-md-12">
                <h3 class="mt-0">
                    Description
                    <span (click)="editDescription()" class="edit btn btn-ghost">
                        <i class="fa cfa cfa-pencil" aria-hidden="true"></i> Modifier
                    </span>
                </h3>
            </div>
            <p class="descriptif p-2" [innerHTML]="displayDescription | nl2br"></p>
            <div class="col-md-12">
                <h3>
                    Caractéristiques
                    <span (click)="editCarac()" class="edit btn btn-ghost">
                        <i class="fa cfa cfa-pencil" aria-hidden="true"></i> Modifier
                    </span>
                </h3>
            </div>
            <div class="col-md-4 mt-2 indicateur">
                <label>
                    Prix affiché
                </label>
                <b>
                    {{ favorite.ad.price | number: '1.0-0' }} €
                </b>
            </div>
            <div class="col-md-4 mt-2 indicateur" *ngIf="favorite.ad_id !== 0">
                <label>
                    Ancienneté de l'annonce
                    <i class="fa fa-question-circle"
                       matTooltip="Il s’agit de la tout première date de publication de l’annonce, et non pas la dernière mise à jour (comme sur les sites immobiliers classiques)."></i>
                </label>
                <b>
                    {{ favorite.ad.first_publication_date }}
                </b>
            </div>
            <div class="col-md-4 mt-2 indicateur">
                <label>Copropriété</label>
                <b *ngIf="favorite.has_copro">Oui ({{ favorite.lot_copro }} Lots)</b>
                <b *ngIf="!favorite.has_copro">Non</b>
            </div>
            <div class="col-md-4 mt-2 indicateur" *ngIf="favorite.estate_sale">
                <label>Type de bien</label>
                <b>{{ favorite.estate_sale }}</b>
            </div>
            <div *ngIf="favorite.floor > 0 || favorite.floor_building > 0" class="col-md-4 indicateur">
                <label>Étage</label>
                <b>{{ favorite.floor != -1 ? favorite.floor : '-' }}{{ favorite.floor_building > 0 ? '/' + favorite.floor_building : '' }}</b>
            </div>
            <div *ngIf="favorite.ad.square_land > 0 || favorite.ad.square_land > 0" class="col-md-4 indicateur">
                <label>Superficie de terrain</label>
                <b>{{ favorite.ad.square_land }} m²</b>
            </div>
            <div *ngIf="favorite.year_building > 0" class="col-md-4 indicateur">
                <label>Année de construction</label>
                <b>{{ favorite.year_building }}</b>
            </div>
            <div *ngIf="favorite.orientation != ''" class="col-md-4 indicateur">
                <label>Orientation</label>
                <b>{{ favorite.orientation | titlecase }}</b>
            </div>
            <div *ngIf="favorite.heating != ''" class="col-md-4 indicateur">
                <label>Chauffage</label>
                <b>{{ favorite.heating | titlecase }}</b>
            </div>
            <div class="col-md-4 indicateur" *ngIf="favorite.ad.adress">
                <label>
                    Adresse de l'annonce
                </label>
                <b>
                    {{ favorite.ad.adress }}
                </b>
            </div>
            <div class="col-md-4 indicateur"
                 *ngIf="favorite.ad.iris && favorite.ad.iris != favorite.ad.city.city_code + '0000'">
                <label>
                    Secteur de l'annonce
                </label>
                <b>
                    {{ cityService.getQuartierName('_gq', favorite.ad_city, favorite.ad.iris.substring(0, 7)) }}
                </b>
            </div>
            <div class="col-md-4 indicateur"
                 *ngIf="favorite.ad.iris && favorite.ad.iris != favorite.ad.city.city_code + '0000'">
                <label>
                    Quartier de l'annonce
                </label>
                <b>
                    {{ cityService.getQuartierName('_iris', favorite.ad_city, favorite.ad.iris) }}
                </b>
            </div>

            <div class="col-md-12">
                <h3>
                    Diagnostics
                    <span (click)="editDiag()" class="edit btn btn-ghost"><i class="fa cfa cfa-pencil"
                                                                             aria-hidden="true"></i> Modifier</span>
                </h3>
            </div>
            <div class="col-6 col-md-4 indicateur">
                <label>Classe énergie</label>
                <app-dpe [extChange]="favoriteChange" [favorite]="favorite"></app-dpe>
            </div>
            <div class="col-6 col-md-4 indicateur">
                <label>GES</label>
                <app-ges [extChange]="favoriteChange" [favorite]="favorite"></app-ges>
            </div>

            <div class="col-md-12">
                <h3>
                    Surfaces annexes
                    <span (click)="editAnnexe()" class="edit btn btn-ghost"><i class="fa cfa cfa-pencil"
                                                                               aria-hidden="true"></i> Modifier</span>
                </h3>
            </div>
            <div class="col-md-12">
                <ul class="row check">
                    <li *ngIf="favorite.bedrooms > 0" class="col-md-4 col-6">{{ favorite.bedrooms }}
                        Chambre{{ favorite.bedrooms > 1 ? 's' : '' }}
                    </li>
                    <li *ngIf="favorite.bathrooms > 0" class="col-md-4 col-6">{{ favorite.bathrooms }}
                        Salle{{ favorite.bathrooms > 1 ? 's' : '' }} de bain
                    </li>
                    <li *ngIf="favorite.shower_rooms > 0" class="col-md-4 col-6">{{ favorite.shower_rooms }}
                        Salle{{ favorite.shower_rooms > 1 ? 's' : '' }} d'eau
                    </li>
                    <li *ngIf="favorite.restrooms > 0" class="col-md-4 col-6">{{ favorite.restrooms }}
                        Toilette{{ favorite.restrooms > 1 ? 's' : '' }}
                    </li>
                    <li *ngIf="favorite.parking > 0" class="col-md-4 col-6">{{ favorite.parking }}
                        Parking{{ favorite.parking > 1 ? 's' : '' }} / Garage{{ favorite.parking > 1 ? 's' : '' }}
                    </li>
                    <li *ngIf="favorite.cellar == true" class="col-md-4 col-6">Cave</li>
                    <li *ngIf="favorite.pool == true" class="col-md-4 col-6">Piscine</li>
                    <li *ngIf="favorite.outside == true" class="col-md-4 col-6">Balcon / Terrasse</li>
                </ul>
            </div>

            <div class="col-md-12">
                <h3>
                    Autres
                    <span (click)="editOther()" class="edit btn btn-ghost"><i class="fa cfa cfa-pencil"
                                                                              aria-hidden="true"></i> Modifier</span>
                </h3>
            </div>
            <div class="col-md-12">
                <ul class="row check">
                    <li *ngIf="favorite.elevator == true" class="col-md-4 col-6">Ascenseur</li>
                    <li *ngIf="favorite.urgent == true" class="col-md-4 col-6">Vente urgente</li>
                    <li *ngIf="favorite.rent == true" class="col-md-4 col-6">Déjà loué</li>
                    <li *ngIf="favorite.work == true" class="col-md-4 col-6">Travaux à prévoir</li>
                    <li *ngIf="favorite.renov == true" class="col-md-4 col-6">Sans travaux</li>
                    <li *ngIf="favorite.owner_type == 'private'" class="col-md-4 col-6">Vendu par un particulier</li>
                    <li *ngIf="favorite.disabled_access == true" class="col-md-4 col-6">Accès handicapé</li>
                    <li *ngIf="favorite.guardian == true" class="col-md-4 col-6">Gardien</li>
                    <li *ngIf="favorite.intercom == true" class="col-md-4 col-6">Interphone</li>
                    <li *ngIf="favorite.closed_view == true" class="col-md-4 col-6">Sans vis-à-vis</li>
                    <li *ngIf="favorite.digital_code == true" class="col-md-4 col-6">Digicode</li>
                </ul>
            </div>

            <div class="col-md-12" *ngIf="favorite.ad_id === 0 && genericLink">
                <h3>Liens</h3>
                <a class="btn btn-sm me-2 mb-2" href="{{ genericLink }}" target="_blank">
                    Voir l'annonce
                </a>
            </div>

            <div class="col-md-12" *ngIf="favorite.ad_id !== 0 && adService.isPartnerAdOfOther(favorite)">
                <h3>Contact</h3>
                <app-partner-interest [favorite]="favorite"></app-partner-interest>
            </div>

            <div class="col-md-12" *ngIf="favorite.ad_id !== 0 && !adService.isPartnerAdOfOther(favorite)">
                <h3>Liens</h3>
                <small *ngIf="favorite.ad.urls == null || favorite.ad.urls.length == 0">
                    Aucun lien actif pour cette annonce
                </small>
                <small *ngIf="favorite.ad.is_active == false">
                    L'annonce semble ne plus être en ligne.
                </small>
                <ng-container *ngIf="favorite.ad.is_active == true">
                    <ng-container *ngFor="let link of favorite.ad.urls">
                        <a [ngClass]="{'btn btn-sm btn-leboncoin me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'leboncoin' && !shouldHideLink(link, favorite.ad.urls)">
                            Leboncoin
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-gensdeconfiance me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'gensdeconfiance'">
                            Gens de confiance
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-seloger me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'seloger' && !shouldHideLink(link, favorite.ad.urls)">
                            SeLoger
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-logicimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'logicimmo'">
                            Logic-immo.com
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-avendrealouer me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'avendrealouer'">
                            Avendrealouer.fr
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-immonotaire me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'immonotaires'">
                            Immo Notaires
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-fnaim me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'fnaim'">
                            FNAIM
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-bienici me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'bienici' && !shouldHideLink(link, favorite.ad.urls)">
                            Bien'ici
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-laforet me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'laforet'">
                            La forêt
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-maisonsetappartements me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'maisonsetappartements'">
                            Maisons et appartements
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-capifrance me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'capifrance'">
                            Capifrance
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-citya me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'citya' && !shouldHideLink(link, favorite.ad.urls)">
                            Citya
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-stephaneplaza me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'stephaneplaza'">
                            Stéphane Plaza
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-safti me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'safti'">
                            Safti
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-orpi me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'orpi'">
                            Orpi
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-century21 me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'century21' && !shouldHideLink(link, favorite.ad.urls)">
                            Century 21
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-iad me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'iad'">
                            IAD
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-efficity me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'efficity'">
                            efficity
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-foncia me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'foncia'">
                            Foncia
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-pap me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'pap'">
                            PAP
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-bellesdemeures me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'bellesdemeures'">
                            Belles demeures
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-figimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'figimmo'">
                            Le figaro
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-guyhoquet me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'guyhoquet' && !shouldHideLink(link, favorite.ad.urls)">
                            Guy Hoquet
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-aucoeurdelimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'aucoeurdelimmo'">
                            Au coeur de l'immo
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-ouestfrance me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'ouestfrance'">
                            Ouest France immo
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-squarehabitat me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'squarehabitat'">
                            Square Habitat
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-btn-bskimmobilier me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'bskimmobilier'">
                            BSK Immobilier
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-btn-btn-nestenn me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'nestenn'">
                            Nestenn
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-human me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'human'">
                            HUMAN immobilier
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-entreparticuliers me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'entreparticuliers'">
                            Entre particuliers
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-paruvendu me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'paruvendu'">
                            Paru vendu
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-lesiteimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'lesiteimmo'">
                            le site immo
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-greenacres me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'greenacres'">
                            Green-Acres
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-immonot me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'immonot'">
                            Immo not
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-etreproprio me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'etreproprio'">
                            etre proprio
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-vivastreet me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'vivastreet'">
                            viva street
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-immoregion me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'immoregion'">
                            immo region
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-domimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'domimmo'">
                            DOMimmo
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-bureauxlocaux me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'bureauxlocaux'">
                            BureauxLocaux
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-luxresidence me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'luxresidence'">
                            Lux Residence
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-surfaceprivee me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'surfaceprivee'">
                            Surface privée
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-residencesimmobilier me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'residencesimmobilier'">
                            Residences immobilier
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-adaptimmobilier me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'adaptimmobilier'">
                            Adaptimmobilier
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-topannonces me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'topannonces'">
                            TopAnnonces
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-optimhome me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'optimhome'">
                            Optimhome
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-era me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'era'">
                            ERA
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-proprietesprivees me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'proprietesprivees'">
                            privees
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-ladresse me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'ladresse'">
                            L'Adresse
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-arthurimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'arthurimmo'">
                            Arthurimmo
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-megagence me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'megagence'">
                            megAgence
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-properstar me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'properstar'">
                            Properstar
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-luxuryestate me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'luxuryestate'">
                            LuxuryEstate
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-espacesatypiques me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'espacesatypiques'">
                            Espaces Atypiques
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-sixiemeavenue me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'sixiemeavenue'">
                            Sixième avenue
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-pietrapolis me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == 'pietrapolis'">
                            Pietrapolis
                        </a>
                        <a [ngClass]="{'btn btn-sm btn-3gimmo me-2 mb-2': true, 'disabled' : link.is_active === false}"
                           href="{{ link.url }}" target="_blank" *ngIf="link.provider == '3gimmo'">
                            3G Immo
                        </a>
                        <span
                            *ngIf="adService.getProviderLib(link.provider) == 'Site partenaire' && favorite.ad.urls.length == 1">
                        Exclusivité : Cette annonce est proposée en direct par l'un de nos partenaires pour les membres Lybox
                    </span>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>
